import { Module } from "vuex";

import { IRootState } from "@/store";
import { getters } from "@/store/modules/nomenclature/getters";
import { actions } from "@/store/modules/nomenclature/actions";
import { mutations } from "@/store/modules/nomenclature/mutations";
import { INomenclatureState, state } from "@/store/modules/nomenclature/state";

export const nomenclature: Module<INomenclatureState, IRootState> = {
  actions,
  mutations,
  state,
  getters,
};
